// @noflow
import { getDataId, getScheduleType, getSelectedEvent, isShowingPopup } from '~/core/state/ui/schedule/selectors';
import { getPropsForProduct, getStateForProduct } from '~/core/state/products/selectors';
import { getIsHueDevice } from '~/core/state/devices/selectors';
import { connect } from 'react-redux';
import { getConfig } from '~/core/state/config/selectors';
import { getPicker } from '../schedule-type';
import PickerContainer from './component';
import { updateEventValue } from '~/core/state/ui/schedule/actions';
import { getIsGroupForProduct } from '~/core/state/products/selectors';
import { getGroupHasHueDevices } from '~/core/state/groups/selectors';

const mapStateToProps = (state, { componentId }) => {
    const config = getConfig(state);

    const productId = getDataId(state, { componentId });

    const isHueDevice = getIsHueDevice(state, { id: productId });
    const isGroup = getIsGroupForProduct(state, { id: productId });
    const groupHasHueDevices = getGroupHasHueDevices(state, { id: productId });
    const productProps = getPropsForProduct(state, { id: productId });
    const productState = getStateForProduct(state, { id: productId });
    const scheduleType = getScheduleType(state, { componentId });
    const selectedEvent = getSelectedEvent(state, { componentId });
    const showingPopup = isShowingPopup(state, { componentId });

    return {
        config,
        isHueDevice,
        isGroup,
        groupHasHueDevices,
        productProps,
        productState,
        scheduleType,
        selectedEvent,
        showingPopup
    };
};

const mapDispatchToProps = { updateEventValue };

const definePicker = (
    { config, scheduleType, selectedEvent, showingPopup, productProps, productState },
    dispatchProps,
    ownProps
) => {
    if (!showingPopup || !dispatchProps || !ownProps) {
        return;
    }

    return getPicker({
        config,
        productProps,
        productState,
        type: scheduleType,
        updateValue: newValue =>
            dispatchProps.updateEventValue({
                componentId: ownProps.componentId,
                updatedEvent: selectedEvent.set('type', scheduleType).set('value', newValue)
            }),
        value: selectedEvent.get('value')
    });
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { showingPopup, isHueDevice, isGroup, groupHasHueDevices } = stateProps;
    const isGroupAndHasHueDevices = isGroup && groupHasHueDevices;

    return {
        ...ownProps,
        isHueDevice,
        isGroupAndHasHueDevices,
        picker: definePicker(stateProps, dispatchProps, ownProps),
        showingPopup
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PickerContainer);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/picker-container/index.js